/**
 * Created by 1 on 2017/8/28.
 */
const SwitchBaseLayer = require('./switchbaselayer/SwitchBaseLayer');
const BaseLayerProviders = require('./switchbaselayer/BaseLayerProviders');
const FeatureHighlight = require('./featurehighlight/FeatureHighlight');
const FeatureLocate = require('./featurelocate/FeatureLocate');
const PopupManager = require('./popupmanager/PopupManager');
const Measure = require('./measure/Measure');
const Measure3D = require('./measure/Measure3D');
const FullScreen = require('./fullscreen/FullScreen');
const ScreenShot = require('./screenshot/ScreenShot');
const MousePosition = require('./mouseposition/MousePosition');
const ThematicMap = require('./thematicmap/ThematicMap');
const LayerManager = require('./layermanager/LayerManager');
/**
 * @namespace
 * @memberOf G
 * @alias G.common
 * @description 常用工具组件
 */
const components = {
    SwitchBaseLayer,
    BaseLayerProviders,
    FeatureHighlight,
    FeatureLocate,
    PopupManager,
    Measure,
    Measure3D,
    FullScreen,
    ScreenShot,
    MousePosition,
    ThematicMap,
    LayerManager
};
module.exports = components;